import { List } from '@kerfjs/ui/list';
import { ListHeader } from '@kerfjs/ui/list-header';
import { ListItem } from '@kerfjs/ui/list-item';
import type { SafeHtml } from 'kerfjs';

import { libraryScope, settingsAreaCollapsed, settingsPage, settingsTab } from '../../../data/state.js';
import { currentCapabilities } from '../../../lib/context.js';
import { SETTINGS_AREAS, settingsAreasFor, settingsLocation } from '../../../lib/settings-nav.js';

/**
 * Role-aware settings navigation as an accordion (HS2-91S2YF): each area is a Kerf
 * `ListHeader` disclosure toggle (the navigation-sidebar recipe's pattern), and the
 * active area lists its one-page sub-pages. Opening an area selects its last-used
 * page; toggling the open area's header folds it away.
 */
export function SettingsSidebar({ view: v }: { view: string }): SafeHtml {
  const location = settingsLocation(v, {
    area: settingsTab.value,
    page: settingsPage.value,
    libraryScope: libraryScope.value,
  });
  return (
    <List gap="l" className="settings-sidebar">
      {settingsAreasFor(currentCapabilities()).map((area) => {
        const active = location?.area === area;
        const expanded = active && !settingsAreaCollapsed.value;
        return (
          <section data-settings-area={area}>
            <ListHeader
              label={SETTINGS_AREAS[area].label}
              toggle
              action="settings-area"
              expanded={expanded}
              triggerAttributes={{ 'data-item-id': area }}
            />
            {expanded
              ? SETTINGS_AREAS[area].pages.map((page) => (
                  <ListItem
                    label={page.label}
                    action="settings-page"
                    itemId={`${area}:${page.id}`}
                    selected={location.page === page.id}
                  />
                ))
              : null}
          </section>
        );
      })}
    </List>
  );
}
